import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, ArrowUpRight, X } from "lucide-react";
import "./style.css";

/**
 * MissingFieldsAlert
 * Modal flutuante centralizado que lista os campos faltantes.
 * Aceita `onFieldClick(fieldId)` para rolar até o campo.
 * Aceita `onClose()` para fechar o modal.
 */
export default function MissingFieldsAlert({
  missingFields = [],
  onFieldClick,
  onClose,
}) {
  // Se nenhum campo estiver faltando, o componente não aparece
  if (!missingFields || missingFields.length === 0) return null;

  const total = missingFields.length;

  const handleOverlayClick = (e) => {
    // Fecha apenas ao clicar fora do card (no overlay)
    if (e.target === e.currentTarget && onClose) onClose();
  };

  return (
    <div
      className="fa-overlay"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="fa-modal-title"
    >
      <div className="fa-card" role="alert" aria-live="polite">
        {/* Botão de fechar (X) */}
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="fa-close-btn"
            aria-label="Fechar alerta"
            title="Fechar"
          >
            <X />
          </button>
        )}

        {/* Cabeçalho do Alerta */}
        <div className="fa-header">
          <div className="fa-icon-box">
            <AlertCircle />
          </div>
          <div>
            <h4 id="fa-modal-title" className="fa-title">
              {total} {total === 1 ? "campo precisa" : "campos precisam"} da sua
              atenção
            </h4>
            <p className="fa-subtitle">
              Preencha os itens abaixo para poder continuar
            </p>
          </div>
        </div>

        {/* Lista de Chips dos Campos Faltantes */}
        <div className="fa-chips">
          {missingFields.map((field) => (
            <button
              key={field.id}
              type="button"
              onClick={() => onFieldClick && onFieldClick(field.id)}
              className="fa-chip"
              title={`Ir para: ${field.label}`}
            >
              <span>{field.label}</span>
              <ArrowUpRight />
            </button>
          ))}
        </div>

        {/* Rodapé informativo */}
        <div className="fa-footer">
          <span className="fa-footer-hint">
            💡 Clique em um campo acima para ir direto até ele
          </span>
        </div>
      </div>
    </div>
  );
}

MissingFieldsAlert.propTypes = {
  missingFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  onFieldClick: PropTypes.func,
  onClose: PropTypes.func,
};
